import React from 'react'
import Load from './Load'
import { AtletaData } from '../services/atletaService'

interface ProfiledetailProps {
    atleta?: AtletaData['atletaPorId']
    loading?: boolean
}

const Profiledetail: React.FC<ProfiledetailProps> = ({ atleta, loading }) => {
    if (loading) {
        return <Load />
    }

    const sobre = atleta?.sobre ?? 'Informações não disponíveis.'
    const localizacao = atleta?.cidade
        ? `${atleta.cidade.nome}-${atleta.cidade.estado.uf}`
        : 'Localização não informada'

    return (
        <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
            <div className="card-body d-block p-4">
                <h4 className="fw-700 mb-3 font-xsss text-grey-900">Sobre</h4>
                <p id='atleta-sobre' className="fw-500 text-grey-500 lh-24 font-xssss mb-0">{sobre}</p>
            </div>
            <div className="card-body d-flex pt-0">
                {/* // TODO: revisar icone Feather "map-pin" - sem mapeamento BI definido */}
                <i className="feather-map-pin text-grey-500 me-3 font-lg"></i>
                <h4 id='atleta-localizacao' className="fw-700 text-grey-900 font-xssss mt-1">{localizacao}</h4>
            </div>
        </div>
    )
}

export default Profiledetail